import { useMemo } from "react";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { Modal, Select } from "components";
import { Button } from "expano-components";
import useCreate from "hooks/useCreate";
import useGet from "hooks/useGet";

const SelectField = (props) => <Select {...props} />;

const AddChannel = ({
  platform_type,
  product_group_id,
  existing_channel_ids,
  handleClose,
  handleSubmit,
  pristine,
  invalid,
  refetch,
  change,
}) => {
  const { is_creating, create } = useCreate({
    path: "/channel_product_groups",
    onSuccess: () => [refetch(), handleClose()],
    onError: (err) => {
      throw new SubmissionError(
        Object.fromEntries(
          Object.entries(err).map(([key, value]) => {
            if (["channel", "product_group"].includes(key)) {
              return [`${key}_id`, value];
            }
            return [key, value];
          })
        )
      );
    },
  });

  const { data: channels } = useGet({
    query: ["channels", existing_channel_ids],
    path: "/channels",
    context: "list",
    search: {
      "q[id_not_in]": existing_channel_ids,
      "q[platform_type_eq]": platform_type,
      per_page: 10_000,
    },
  });

  const channel_options = useMemo(() => {
    return channels?.map(({ id, identifier }) => ({
      label: identifier,
      value: id,
    }));
  }, [channels]);

  const onSubmit = ({ channel_id }) =>
    create({
      channel_id,
      product_group_id,
    });

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: "Przypisz kanał",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={pristine || invalid || is_creating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <Field
        name="channel_id"
        label="Kanał sprzedażowy"
        component={SelectField}
        options={channel_options}
        handleChange={(value) => change("channel_id", value)}
      />
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.channel_id) {
    errors.channel_id = "Kanał jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "create_channel_product_group",
  initialValues: { channel_id: null },
  validate,
})(AddChannel);
